import {
  pageInfo,
  PerkSectionItemsFragment,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetHelpPartnerOffersQuery = gql`
  query FetchSpecializedPerksSection(
    $perkSectionsId: ID
    $first: Int
    $after: String
    $perkSectionsItemsInput: PerkSectionsItemsInput
    $perkSectionsInput: PerkSectionsInput
  ) {
    myPartnerOffers {
      perkSections(
        id: $perkSectionsId
        first: $first
        after: $after
        perkSectionsInput: $perkSectionsInput
      ) {
        name
        edges {
          __typename
          node {
            id
            name
            sectionStyleType
            items(input: $perkSectionsItemsInput) {
              ...PerkSectionItemsFragment
            }
            hasNext
          }
        }
        pageInfo {
          ...pageInfo
        }
      }
    }
  }
  ${PerkSectionItemsFragment}
  ${pageInfo}
`;

export default GetHelpPartnerOffersQuery;
